import { render, staticRenderFns } from "./UserTransinfo.vue?vue&type=template&id=6fbd535c&"
import script from "./UserTransinfo.vue?vue&type=script&lang=js&"
export * from "./UserTransinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports